const trimSlash = (value = '') => value.replace(/\/+$/, '');

const join = (base, path = '') => {
  const normalizedBase = trimSlash(base);
  if (!path) return normalizedBase;
  const normalizedPath = path.replace(/^\/+/, '');
  return `${normalizedBase}/${normalizedPath}`;
};

export const YERVIP_BASE_URL = trimSlash(process.env.VUE_APP_YERVIP_BASE_URL || 'https://yervip.com');
export const CRM_API_BASE_URL = trimSlash(process.env.VUE_APP_CRM_API_BASE || 'https://yervip.com/api/v1');
export const BACK_API_BASE_URL = trimSlash(process.env.VUE_APP_BACK_API_BASE || process.env.VUE_APP_API_BASE || 'https://back.yervip.com/api/v1');
export const PRODUCT_API_BASE_URL = trimSlash(process.env.VUE_APP_PRODUCT_API_BASE || 'https://product.yervip.com/api/v1');

export const crmApiUrl = (path = '') => join(CRM_API_BASE_URL, path);
export const backApiUrl = (path = '') => join(BACK_API_BASE_URL, path);
export const productApiUrl = (path = '') => join(PRODUCT_API_BASE_URL, path);
export const yervipUrl = (path = '') => join(YERVIP_BASE_URL, path);

